module.exports = {
      id: "email-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#email",
      toString: function () {
        return this.url;
      }
    }